export const statusRecipe = {
	approve: 'RA',
	verification: 'RV',
	rejected: 'RI',
	RA: 'Receta aprobada',
	RV: 'Receta por verificación',
	RI: 'Receta rechazada',
};
